module.exports = __webpack_public_path__ + "static/media/baseline-directions_car-24px.7ad95978.svg";